<template>
  <div class="login">
    <!-- <VueSlickCarousel
      :dots="true"
      class="login__carousel"
      :autoplay="true"
      :autoplaySpeed="5000"
      :arrows="false"
    >
      <div class="login__hero login__hero--1">
        <div class="left">
          <h1>
            Shark Tank Colombia <br /> presenta DiDi Lab. <br />
            <span> Laboratorio de ideas para la reactivación del país.</span>
          </h1>
        </div>
        <div></div>
      </div>
      <div class="login__hero login__hero--2">
        <div class="left">
          <h1>
            ¿Tienes un emprendimiento que <br /> quieres llevar al siguiente nivel?
            <br />
            <span>
              regístrate ya en DiDi Lab y seamos parte de la
              reactivación de la economía.</span
            >
          </h1>
        </div>
        <div></div>
      </div>
      <div class="login__hero login__hero--3">
        <div class="left">
          <h1>
            El emprendimiento ganador se llevará <br /> 50 millones de pesos para
            invertir en su negocio y una consultoría exclusiva <br />
            <span
              >por parte del Centro de Emprendimiento de la Universidad de los
              Andes.</span
            >
          </h1>
        </div>
        <div></div>
      </div>
    </VueSlickCarousel> -->

    <form @submit.prevent="login">
      <div class="input-container">
        <label for="email">Email</label>
        <input type="email" id="email" v-model="email" required>
      </div>

      <div class="input-container">
        <label for="password">Contraseña</label>
        <input type="password" id="password" v-model="password" required>
      </div>

      <button class="btn-submit">
        <CircleLoader color="#FFFFFF" v-if="isLoading" />
        <span v-else>Ingresar</span>
      </button>
    </form>

    <Allies />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Allies from '@/components/Allies.vue';
import CircleLoader from '@/components/CircleLoader.vue';
import { auth } from "../firebase";
export default {
  components: {
    VueSlickCarousel,
    Allies,
    CircleLoader
  },
  data(){
    return {
      email: '',
      password: '',
      isLoading: false
    }
  },
  methods: {
    async login() {
      this.isLoading = true
      try {
        const user = await auth.signInWithEmailAndPassword(
          this.email,
          this.password
        );
        this.$router.push('/dashboard')
      } catch (error) {
        console.log(error)
      }

      this.isLoading = false;

    }
  }
}
</script>

<style lang="scss" scoped>
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../assets/images/bg-2.jpg") no-repeat;
    background-size: cover;
    background-position-y: 45%;

    &__carousel {
      width: 100%;
    }

    &__hero {
      height: 70vh;
      width: 100%;
      padding: 2rem 4rem;
      display: grid !important;

      @include phone {
        padding: 1rem 2rem;
        height: 30vh;
      }

      &--1 {
        background: url("../assets/images/home/hero_1.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 40% 60%;

        @include phone {
          grid-template-columns: 60% 40%;
        }
      }
      &--2 {
        background: url("../assets/images/home/hero_2.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 50% 50%;

        @include phone {
          grid-template-columns: 80% 20%;
        }
      }
      &--3 {
        background: url("../assets/images/home/hero_3.jpg") no-repeat;
        background-size: cover;
        grid-template-columns: 60% 40%;

        @include phone {
          grid-template-columns: 80% 20%;
        }
      }

      .left {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        h1 {
          color: white;

          @include phone {
            font-size: 0.8rem;
            width: 100%;
          }

          span {
            font-weight: 100;
          }
        }
      }
    }

    form {

      margin: 5rem auto 3rem auto;
      width: 40%;

      @include phone {
        width: 90%;
      }

      .input-container {
        display: flex;
        flex-direction: column;
        margin-bottom: 1.5rem;
        position: relative;

        label {
          color: white;
          margin-bottom: 1rem;
        }

        input {
          background-color: white;
          border-radius: 20px;
          padding: 5px 10px;
        }
      }

      .btn-submit {
        background-color: $main-color;
        color: white;
        margin: 1rem auto;
        display: block;
        padding: 5px 60px;
        border-radius: 20px;
      }
    }
  }
</style>